import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GENERATE_INVOICE } from "../../../../Urls.js";

const initialState = {
    generateInvoiceData: { data: [], loading: false },
};

export const generateInvoice = createAsyncThunk(
  "app/get/payment/generateInvoice",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("Thunk payload:", payload); // check payload here
      const response = await axios.post(GENERATE_INVOICE, {
        xml: payload.xml,
        xslt: payload.xslt,
      });
      return response.data; // usually return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to generate invoice");
    }
  }
);




export const billingSlice = createSlice({
    name: "billingSlice/billing",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(generateInvoice.pending, (state) => {
                state.generateInvoiceData.loading = true;
            })
            .addCase(generateInvoice.fulfilled, (state, action) => {
                state.generateInvoiceData.loading = false;
                state.generateInvoiceData.data = action?.payload?.data?.data;
            })
            .addCase(generateInvoice.rejected, (state) => {
                state.generateInvoiceData.loading = false;
                state.generateInvoiceData.data =[];
            })
    }
});


export const { } = billingSlice.actions;

export default billingSlice.reducer;